/*
 * @Author: edvardchen
 * @Date: 2017-11-08 19:38:28
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-03-20 23:05:13
 */

// @flow
import { TWEET_SUCCESS } from './actions';
import { type Comment, type Reducer } from '../types';

/* immutable update */
const insertIntoSubcomments = (list: Array<*>, comment: *) =>
  list.map((item) => {
    const { parentId } = (comment: Object);
    if (item.id === parentId) {
      const { subComments: { items = [], total = 0 } = {} } = item;
      if (items.find((itm) => itm.id === comment.id)) {
        return item;
      }
      return {
        ...item,
        subComments: {
          items: [...items, comment],
          total: total + 1,
        },
      };
    }
    return item;
  });

const reducer: Reducer = (state, { type, payload }) => {
  const { hotComments, allComments, showNestedComments, entry } = state;
  switch (type) {
    case TWEET_SUCCESS: {
      if (!payload) {
        return state;
      }
      const {
        referId,
        content,
        images,
        id,
        parentCommentId = '',
        postId,
        circleId,
      }: {
        referId?: string,
        content: string,
        images: any[],
        id: string,
        parentCommentId?: string,
        postId?: string,
        circleId?: string,
      } = payload;

      const { circleUserId = '', nickname, head, type: userType } = state.user;
      const newComment: Comment = {
        referComment: undefined,
        parentId: parentCommentId,
        id,
        time: '刚刚',
        content,
        images,
        user: {
          id: circleUserId,
          name: nickname,
          accountType: userType,
          faceIcon: head,
          isAuthor: true,
        },
        bNicePost: false,
        postId,
        circleId,
        commentNum: 0,
        eFrom: 0,
      };

      if (entry === 'article') {
        newComment.isNewComment = true;
      }
      if (referId) {
        const referComment = [].concat(allComments.items, hotComments).find((item) => item.id === referId);
        referComment && (newComment.referComment = Object.assign({}, referComment));
      }
      const existed = allComments.items.find((item) => item.id === newComment.id);
      if (existed) {
        return state;
      }
      if (showNestedComments) {
        // 假装成楼中楼结构
        newComment.subComments = {
          items: [],
          total: 0,
        };
      }

      if (parentCommentId) {
        if (state.comment && state.comment.id === parentCommentId) {
          // 二级评论页
          return {
            ...state,
            allComments: {
              ...allComments,
              items: [newComment, ...allComments.items],
            },
          };
        }
        return {
          ...state,
          hotComments: insertIntoSubcomments(hotComments, newComment),
          allComments: {
            ...allComments,
            items: insertIntoSubcomments(allComments.items, newComment),
          },
        };
      }

      let referComment: ?Comment;
      if (referId) {
        referComment =
          hotComments.find((item) => item.id === referId) || allComments.items.find((item) => item.id === referId);
      }
      if (referComment) {
        newComment.referComment = referComment;
      }
      return {
        ...state,
        allComments: {
          ...allComments,
          items: [newComment, ...allComments.items],
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
